import {createSelector} from 'reselect';

import {selectCountryCode, selectCountryPrimaryContact} from '../../common/util/selectors';
import FEATURE_FLAGS from '../../utils/featureFlags';
import {eventCountrySelector} from '../eventData/selectors';
import {featureFlagsSelector} from '../gsConfig/selectors';

const showForcePrivateStatusSelector = createSelector(featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.sell.sellerInfo.showPrivateSellerOption]);

const isParkingEnabledSelector = createSelector(featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.searchResults.isParkingEnabled]);

const isFaceValueMandatoryEnabledSelector = createSelector(featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.faceValue.MandatoryEnabled]);

const isFaceValueEventBasedEnabledSelector = createSelector(featureFlagsSelector, eventCountrySelector,
  (features, eventCountry) => !!features[`${[FEATURE_FLAGS.common.faceValue.eventBasedEnabled]}.${eventCountry}`]);

const bannerEUBankAccountEnabledSelector = createSelector(
  featureFlagsSelector,
  selectCountryCode,
  selectCountryPrimaryContact,
  (features, userCountry, primaryContact) => userCountry ?
    !!features[`${[FEATURE_FLAGS.common.EUBankAccountEnabled]}.${userCountry}`] :
    !!features[`${[FEATURE_FLAGS.common.EUBankAccountEnabled]}.${primaryContact}`]
);

const isDsaActiveSelector = createSelector(featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.isDsaActive]);

const isDsaExtraFieldsActiveSelector = createSelector(featureFlagsSelector,
  (features) => !!features[FEATURE_FLAGS.common.isDsaExtraFieldsActive]);

export {
  showForcePrivateStatusSelector,
  isParkingEnabledSelector,
  isFaceValueMandatoryEnabledSelector,
  isFaceValueEventBasedEnabledSelector,
  bannerEUBankAccountEnabledSelector,
  isDsaActiveSelector,
  isDsaExtraFieldsActiveSelector,
};
